// istanbul ignore file
import InputLimiter from './InputLimiter';
export default InputLimiter;